import { Component, OnInit, OnDestroy, Input, EventEmitter, Output } from '@angular/core';
import { RightSideDrawerService } from '../../shared/right-side-drawer/right-side-drawer.service';
import { AdminClientUsersService } from 'src/app/admin/admin-client-users/admin-client-users.service';
import { ToastrService } from '@kpmg-tax/ui';
import { Messages } from '../../shared/constants/messages';
import { ClientUserResponse } from '../../shared/models/client-user-response.model';
import { UsersService } from 'src/app/admin/users/users.service';
import { SESSION_CONST } from 'src/app/shared/constants/session-constants';
import { SessionService } from '../../shared/session-service/session.service';
import { Observable, of } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';
import { role } from 'src/app/shared/constants/role-enum';
import { BaseResponse } from 'src/app/shared/models/base-response.model';
import { UserDetails } from 'src/app/core/models/user-details.model';
import { UserDataService } from 'src/app/core/services/user-data.service';
import { UpdateUserRequest } from '../../shared/models/update-user-request.model';
import { APP_CONSTANTS, File_TYPE, MANAGE_CLIENT_ADMIN_USER, SUPPORTED_FILE_TYPE } from 'src/app/shared/constants/app-constants';
import { LoadingIndicatorService } from '@kpmg-tax/ui';
import { TooltipOptions } from 'ng2-tooltip-directive';

@Component({
    selector: 'client-user-management',
    templateUrl: './client-usermanagement.component.html',
    styleUrls: ['./client-usermanagement.component.scss']
})
export class ClientUserManagementComponent implements OnInit, OnDestroy {
    tableDataFiltered: ClientUserResponse[] = [];
    tableDataFilteredOriginal: ClientUserResponse[];
    @Input() drawerTitle = '';
    @Input() clientId: number;
    clients: any = [];
    selectedClient = 0;
    isSelected = false;
    selected: any[] = [];
    masterCheckboxControl = false;
    editable = new Map<number, boolean>();
    editableAlias = new Map<number, boolean>();
    editableField: any;
    clientName: string;
    selectedNickName: string;
    selectedClientName: any;
    ClientAlias: string;
    isUserListRefreshTriggered = false;
    noResults: boolean;
    noResultflag: boolean;
    engagementClient = '';
    searchFilter = '';
    disableBulkClient = true;
    clientAdmin = role.clientAdmin;
    checked: any[] = [];
    currentUserId: number;
    user: UserDetails;
    hasAdminAccess = false;
    isClientAdmin = false;
    addClientText = '';
    addBulkUserText = '';
    guidance = MANAGE_CLIENT_ADMIN_USER.GUIDANCE_TOOLTIP;
    isErrorMessage = false;
    disableprovisionFailedUsers = false;
    toolTipOptions: TooltipOptions = {
        placement: 'left'
    } as TooltipOptions;
    @Output() drawerWidthMangerClientUser = new EventEmitter<any>();

    constructor(
        public rightSideDrawerService: RightSideDrawerService,
        public toastrService: ToastrService,
        public _clientUsersService: AdminClientUsersService,
        public _usersService: UsersService,
        public sessionService: SessionService,
        private _userDataService: UserDataService,
        private _loader: LoadingIndicatorService) {
        this.clientName = this.sessionService.getSession(SESSION_CONST.CLIENTNAME);
        this.toolTipOptions.tooltipClass = "mapping-text-tooltip";
    }

    ngOnInit() {
        
        this.GetUserList(this.clientId);
        this.selectedClient = this.clientId;
        this.selected = [];
        this._clientUsersService.userListRefresh.subscribe(x => {
            if (x === true) {
                this.isUserListRefreshTriggered = true;
                this.clientName = this.sessionService.getSession(
                    SESSION_CONST.CLIENTNAME
                );
                this.selectedClientName = this.sessionService.getSession(
                    SESSION_CONST.CLIENTNAME
                );

                this.GetUserList(this.clientId);
            } else {
                this.isUserListRefreshTriggered = false;
            }
        });
        this.currentUserId = Number(
            this.sessionService.getSession('currentUserId')
        );
        this.getRoles();
        this.drawerWidthMangerClientUser.emit('calc(96vw - 100px)');
    }
    private getRoles() {
        this._userDataService.userDetails$.subscribe(userDetails => {

            this.user = userDetails;

            this.hasAdminAccess = (this.user.roleId === role.admin) || (this.user.roleId === role.champion) ? true : false;

            this.isClientAdmin = this.user.roleId === role.clientAdmin ? true : false;

            this.addClientText = this.isClientAdmin ? APP_CONSTANTS.ADD_CLIENTADMIN_USER : APP_CONSTANTS.ADD_CLIENT;

            this.addBulkUserText = this.isClientAdmin ? APP_CONSTANTS.ADD_CLIENTADMIN_BULK_CLIENT : APP_CONSTANTS.ADD_BULK_CLIENT;

            if (this.isClientAdmin) {
                this.getclientUsersforAdmin();
            }
        });

    }
    getclientUsersforAdmin() {
        this.GetUserList(this.clientId);
    }

    private getNotNullString(str: any) {
        return str ? str.trim() : '';
    }

    private setSelectedClientProperties(client: any) {
        this.selectedClient = client.clientId;
        this.selectedNickName = this.getNotNullString(client.alias);
        this.selectedClientName = this.getNotNullString(client.clientName);
    }

    getUsersByClientName(event: any) {
        if (event.target.value && event.target.value.trim().length > 0) {
            this.sessionService.setSession(
                SESSION_CONST.CLIENTNAME,
                event.target.value.trim().toLowerCase()
            );
            const clientDetail = this.clients.find(
                x =>
                    x.clientName.trim().toLowerCase() ===
                    event.target.value.trim().toLowerCase()
            );
            if (clientDetail && clientDetail.clientId > 0) {
                this.clientId = Number(clientDetail.clientId);
                this.ClientAlias = clientDetail.alias ? clientDetail.alias.trim() : '';
                this.GetUserList(clientDetail.clientId);
                this.disableBulkClient = false;
            }
        } else {
            this.selectedClient = 0;
            this.clientName = '';
            this.tableDataFiltered = [];
            this.disableBulkClient = true;
        }
    }

    GetClientUsers() {
        this.GetUserList(this.selectedClient);
        this.selected = [];
    }

    GetUserList = (clientId: number) => {
        this.clientId = clientId;
        this.clientName = this.selectedClientName;
        this.sessionService.setSession(SESSION_CONST.ADDBULKUSERCLIENTID, clientId.toString());
        this._clientUsersService.GetUser(clientId, true).subscribe(
            data => {
                this.disableBulkClient = false;
                this.disableprovisionFailedUsers = false;
                if (data && data.result !== null) {
                    var errorMessageRecord = data.result.filter(x => x.errorMessage != null && x.errorMessage !== '');
                    if (errorMessageRecord.length > 0) {
                        this.isErrorMessage = true;
                        data.result = data.result.sort((a, b) => (a.errorMessage > b.errorMessage) ? -1 : 1);
                    }
                    else {
                        this.isErrorMessage = false;
                    }
                    this.tableDataFiltered = data.result;
                    this.tableDataFilteredOriginal = data.result;
                    for (let i = 0; i < this.tableDataFiltered.length; i++) {
                        this.editable[i] = false;
                    }
                    if (this.tableDataFilteredOriginal) {
                        this.tableDataFiltered = this.tableDataFilteredOriginal.filter(
                            x => x.isDelete === false
                        );
                    }
                    this.tableDataFiltered = this.tableDataFiltered.filter((d) =>
                        d.userName
                            .toString()
                            .toUpperCase()
                            .indexOf(this.searchFilter) !== -1 ||
                        d.email
                            .toString()
                            .toUpperCase()
                            .indexOf(this.searchFilter) !== -1 ||
                        d.displayName
                            .toString()
                            .toUpperCase()
                            .indexOf(this.searchFilter) !== -1 ||
                        d.clientName
                            .toString()
                            .toUpperCase()
                            .indexOf(this.searchFilter) !== -1 ||
                        !this.searchFilter);

                    this.selected = [];
                } else {
                    this.isErrorMessage = false;
                    this.tableDataFiltered = [];
                    this.tableDataFilteredOriginal = [];
                }
            });
    };

    addUser = () => {
        this._clientUsersService.setFunctionTypeAndData(true, true);
        if(this.rightSideDrawerService.manageClientUserData)
        {     
            this.rightSideDrawerService.singleRowAddData = this.rightSideDrawerService.manageClientUserData.clientName;
            this.rightSideDrawerService.manageClientUserData = {
                clientId : this.rightSideDrawerService.manageClientUserData.clientId,
                clientName : this.rightSideDrawerService.manageClientUserData.clientName,
                isManageClientUser : true
            };
        }else{
            this.rightSideDrawerService.singleRowAddData = this.rightSideDrawerService.singleRowEditData.result.clientName;
            this.rightSideDrawerService.manageClientUserData = {
                clientId : this.rightSideDrawerService.singleRowEditData.result.clientId,
                clientName : this.rightSideDrawerService.singleRowEditData.result ? this.rightSideDrawerService.singleRowEditData.result.clientName.trim() : null,
                isManageClientUser : true
            };
        }

        this.rightSideDrawerService.openRightSideDrawer('add-user-form');
    };

    addBulkUser = () => {
        if (this.selectedClient === null || this.selectedClient <= 0) {
            this.toastrService.setWarningMessage('Please select a client name.');
            return;
        }
        this._clientUsersService.setFunctionTypeAndData(true, true);
        this.rightSideDrawerService.singleRowAddData = this.sessionService.getSession(SESSION_CONST.ADDBULKUSERCLIENTID);
        if(this.rightSideDrawerService.manageClientUserData)
        {     
            this.rightSideDrawerService.manageClientUserData = {
                clientId : this.rightSideDrawerService.manageClientUserData.clientId,
                clientName : this.rightSideDrawerService.manageClientUserData.clientName,
                isManageClientUser : true
            };
        }else{
            this.rightSideDrawerService.singleRowAddData = this.rightSideDrawerService.singleRowEditData.result.clientName;
            this.rightSideDrawerService.manageClientUserData = {
                clientId : this.rightSideDrawerService.singleRowEditData.result.clientId,
                clientName : this.rightSideDrawerService.singleRowEditData.result ? this.rightSideDrawerService.singleRowEditData.result.clientName.trim() : null,
                isManageClientUser : true
            };
        }
        this.rightSideDrawerService.openRightSideDrawer('custom-uploader', APP_CONSTANTS.ADD_MULTIPLE_USERS, {
            filetype: File_TYPE.CLIENT_USER,
            isFileupload: true,
            clientId: this.selectedClient,
            supportedFileType: SUPPORTED_FILE_TYPE.UPLOAD,
        });
    };

    loadGrid() {
        if (this.isClientAdmin) {
            this.getclientUsersforAdmin();
        }
        else {
            this.GetClientUsers();
        }
    }

    editUser = (row: any) => {
        if (row.displayName === '') {
            this.toastrService.setErrorMessage('Name cannot be blank');
            this.loadGrid();
            return;
        }
        const editNameData: UpdateUserRequest = {
            userId: row.userId as number,
            userName: row.userName as string,
            firstName: row.firstName as string,
            lastName: row.lastName as string,
            displayName: row.displayName as string,
            email: row.email as string,
            isStageUser: row.errorMessage !== '' ? true : false
        };
        this._clientUsersService.updateClientUser(editNameData).subscribe(data => {
            if (data.result !== 'Same' && data.result !== 'Sign-in name already exists.') {
                if (data.success) {
                    this.toastrService.setSuccessMessage('User successfully updated.');
                } else {
                    if (this.isClientAdmin) {
                        this.getclientUsersforAdmin();
                    }
                    else {
                        this.GetClientUsers();
                    }
                    this.toastrService.setErrorMessage(data.errorMessage);
                }
            }
            if (data.result === 'Sign-in name already exists.') {
                if (this.isClientAdmin) {
                    this.getclientUsersforAdmin();
                }
                else {
                    this.GetClientUsers();
                }
                this.toastrService.setErrorMessage(data.result);
            }
        });
    };
    deleteRowProject = (row: any) => {
        this._clientUsersService.deleteUser(row.userId).subscribe(
            data => {
                if (data.success) {
                    if (this.isClientAdmin) {
                        this.getclientUsersforAdmin();
                    }
                    else {
                        this.GetUserList(this.selectedClient);
                    }
                } else if (
                    data !== null &&
                    !data.success &&
                    data.errorMessage === 'ASSIGNED'
                ) {
                    this.toastrService.setErrorMessage(
                        'The user is already assigned to this study.'
                    );
                }
            });
    };
    selectSingle(row: any, isSelected: boolean) {
        if (isSelected){
            this.selected.push(row);            
        } else {
            const filtered = this.selected.filter(item => item.userId !== row.userId);
            this.selected = [];
            this.selected = filtered;
            this.masterCheckboxControl = false;
        }
    }

    selectMultiple() {
        this.masterCheckboxControl = !this.masterCheckboxControl;
        if (this.masterCheckboxControl === true) {
            this.selected = this.tableDataFiltered;
        } else {
            this.selected = [];
        }
    }
    sendDeletionRequest() {
        let deleteEmployeedata;
        if (this.masterCheckboxControl === true) {
            deleteEmployeedata = this.tableDataFiltered.map(
                ({ userId, userName, email, errorMessage }) => ({ userId, userName, email, errorMessage })
            );
        } else {
            deleteEmployeedata = this.selected.map(({ userId, userName, email, errorMessage }) => ({
                userId,
                userName,
                email,
                errorMessage
            }));
        }
        deleteEmployeedata.forEach(element => {
            element.isStageUser = element.errorMessage !== '' ? true : false,
                element.clientId = this.clientId ? this.clientId : 0
        });
        this._usersService
            .sendRequestforDeletion(deleteEmployeedata)
            .subscribe(data => {
                const message = data?.success
                    ? Messages.Admin.User.DeleteUserAPISuccess
                    : Messages.Admin.User.DeleteUserAPIFailure;
                this.deletionCompleted(message);
            });
    }

    private deletionCompleted(message: string) {
        this.toastrService.setSuccessMessage(message);
        this.selected = [];
        this.isSelected = false;
        this.masterCheckboxControl = false;
        if (this.isClientAdmin) {
            this.getclientUsersforAdmin();
        }
        else {
            this.GetUserList(this.selectedClient);
        }
    }

    searchDataTableFilter = event => {
        if (event.target.value) {
            const filterInputValue = event.target.value.trim().toUpperCase();
            this.searchFilter = filterInputValue;
            this.tableDataFiltered = this.tableDataFilteredOriginal;
            this.tableDataFiltered = this.tableDataFiltered.filter((d) => {
                return (
                    d.userName
                        .toString()
                        .toUpperCase()
                        .indexOf(filterInputValue) !== -1 ||
                    d.email !== null && d.email
                        .toString()
                        .toUpperCase()
                        .indexOf(filterInputValue) !== -1 ||
                    d.displayName
                        .toString()
                        .toUpperCase()
                        .indexOf(filterInputValue) !== -1 ||
                    d.clientName
                        .toString()
                        .toUpperCase()
                        .indexOf(filterInputValue) !== -1 ||
                    d.errorMessage
                        .toString()
                        .toUpperCase()
                        .indexOf(filterInputValue) !== -1 ||
                    !filterInputValue
                );
            });
        } else if (event.target.value === '') {
            this.tableDataFiltered = this.tableDataFilteredOriginal;
        }
    };
    editClick(rowindex): void {
        this.editableField = rowindex;
        if (this.editable[rowindex] === false) {
            document.getElementById(rowindex).focus();
            this.editable[rowindex] = true;
        } else {
            document.getElementById(rowindex).focus();
            this.editable[rowindex] = false;
        }
    }
    editAliasClick(index): void {
        document.getElementById(index).focus();
    }
    editNickname = (alias, clientId) => {
        const UpdateData = {
            Alias: alias,
            clientId: clientId
        };
        this._clientUsersService.EditNickName(UpdateData).subscribe(data => {
            if (data.result !== 'Same') {
                if (data.success) {
                    this.toastrService.setSuccessMessage('Alias name successfully updated.');
                    this.GetClientUsers();
                    const found = this.clients.findIndex(x => x.clientId === clientId);
                    this.clients[found].alias = alias;
                    this.selectedNickName = alias;
                } else {
                    this.toastrService.setErrorMessage(data.errorMessage);
                }
            }
        });
    };
    editClientNickname = (alias, clientNmae) => {
        if (clientNmae) {
            const clientDetail = this.clients.find(
                x => x.clientName.trim() === clientNmae.trim()
            );
            if (clientDetail) {
                const UpdateData = {
                    Alias: alias,
                    clientId: clientDetail.clientID
                };
                this._clientUsersService.EditNickName(UpdateData).subscribe(data => {
                    if (data.result !== 'Same') {
                        if (data.success) {
                            this.toastrService.setSuccessMessage('Alias name successfully updated.');
                            this.GetClientUsers();
                            const found = this.clients.findIndex(
                                x => x.clientId === clientDetail.clientID
                            );
                            this.clients[found].alias = alias;
                            this.ClientAlias = alias;
                        } else {
                            this.toastrService.setErrorMessage(data.errorMessage);
                        }
                    }
                });
            }
        }
    };

    getselectedNickName(clientid): void {
        const clientDetail = this.clients.find(x => x.clientId === clientid);
        if (clientDetail) {
            this.selectedNickName = clientDetail.alias
                ? clientDetail.alias.trim()
                : '';
            this.selectedClientName = clientDetail.clientName
                ? clientDetail.clientName.trim()
                : '';
            this.ClientAlias = clientDetail.alias ? clientDetail.alias.trim() : '';
        }
    }

    editFirstOrLastName(elementIndex: number, column: string): void {
        const columnElement: HTMLElement = document.getElementById(elementIndex.toString() + column);
        if (columnElement) {
            columnElement.focus();
        }
    }

    editUserName(elementIndex: number, column: string): void {
        const columnElement: HTMLElement = document.getElementById(elementIndex.toString() + column);
        if (columnElement) {
            columnElement.focus();
        }
    }

    updateDisplayName(event, row): void {
        if (event) {
            const currentDisplayName = row.displayName;
            row.displayName = row.firstName?.trim() + ' ' + row.lastName?.trim();
            row.displayName = row.displayName === undefined ? '' : row.displayName;
            if (row.displayName?.trim().length == 0) {
                row.displayName = currentDisplayName;
            }
        }
    }

    ngOnDestroy() {
        //this.rightSideDrawerService.closeRightSideDrawer();
    }

    onClientSelected($event: any) {
        this.hideClearButton = false;
        this.selectedClient = $event.item.clientId;
        this.selectedClientName = $event.item.clientName;
        this.sessionService.setSession(SESSION_CONST.CLIENTNAME, this.selectedClientName);
        this.engagementClient = $event.item.clientName;
        this.disableBulkClient = false;
        this.GetClientUsers();
        this.getselectedNickName($event.item.clientId);
    }


    // format for clients search
    clientFormatter = (result: any) =>
        typeof result.clientName === 'undefined' ? result : result.clientName;

    // Autosuggest for Existing Client Names
    searchExistingClients = (searchPhrase$: Observable<any>) =>
        searchPhrase$.pipe(
            debounceTime(150), // Wait 150 milliseconds for typing to stop
            distinctUntilChanged(), // Only continue if the current search term is different that it was before the user started typing
            tap(term => {
                // Remove "no results" message in case it was displayed from the previous search
                this.noResults = false;
            }),
            switchMap(term => {
                if (term !== '') {
                    // Process the search term entered
                    return this.searchClients(term).pipe(
                        switchMap(data => {
                            this.engagementClient = term as string;
                            return of(data);
                        }),
                        catchError(() => {
                            this.noResults = true;
                            return of([]);
                        })
                    );
                } else {
                    return of(this.clients);
                }
            })
        );

    // Filter clients autosuggest
    private searchClients(term: any): Observable<any> {
        if (this.clients) {
            return of(
                this.clients.filter((item: any) =>
                    item.clientName.toLowerCase().includes(term.toLowerCase())
                )
            );
        } else {
            return of([]);
        }
    }
    hideClearButton = false;

    roleCheckValue(event, row: any, role: string) {
        const ClientData = {
            userId: row.userId,
            userName: row.userName,
            roleId: null,
            isSelected: event.target.checked
        };
        if (role === 'clientadmin') {
            ClientData.roleId = this.clientAdmin;
        }

        if (event.target.checked === true) {
            this.checked.push(row);

        } else {
            const filtered = this.checked.filter(item => item.userId !== row.userId);
            this.checked = [];
            this.checked = filtered;

        }
        this._usersService.AddUpdateRole(ClientData).subscribe(
            (data: BaseResponse) => {
                if (data.success) {
                    if (this.isClientAdmin) {
                        this.getclientUsersforAdmin();
                    }
                    else {
                        this.GetClientUsers();
                    }
                    this.toastrService.setSuccessMessage(
                        Messages.Admin.User.UpdateUserRoleSuccess
                    );
                } else {
                    this.toastrService.setErrorMessage(
                        Messages.Admin.User.UpdateUserRoleFailure
                    );
                }
            }
        );
    }
    getClientAdminRole(row) {
        const role = row.roleIds
            ?.map((e) => {
                return e;
            })
            .indexOf(this.clientAdmin);
        if (role > -1) {
            return true;
        } else {
            return false;
        }
    }
    provisionFailedUsers() {
        this._loader.display(true, true);
        this._clientUsersService.provisionFailedUsers(this.clientId).subscribe(data => {
            if (data.result) {
                if (data.success) {
                    this._loader.display(false);
                    this.disableprovisionFailedUsers = true;
                    this.toastrService.setSuccessMessage(APP_CONSTANTS.FAILED_MULTIPLE_USERS_MESSAGE);
                } else {
                    this._loader.display(false);
                    this.disableprovisionFailedUsers = false;
                    this.toastrService.setErrorMessage("Issues encountered with bulk user creation. Please contact the application support team by clicking the envelope icon on the top right corner of your screen.");
                }
            }
            else {
                this._loader.display(false);
                this.disableprovisionFailedUsers = false;
                this.toastrService.setErrorMessage("Issues encountered with bulk user creation. Please contact the application support team by clicking the envelope icon on the top right corner of your screen.");
            }
        });
    }
}
